import { ApiGet } from './Common.ts'
import { GetOrderEntryConnectorUrl, GetWebConnectorUrl } from '../stores/SettingsStore.ts'
import type {
  ICountryResponse,
  IStateResponse,
  ICodeResponse
} from '../types/CountryCultureTypes.d.ts'


export async function CountryGetList(): Promise<ICountryResponse> {
  const url = await GetOrderEntryConnectorUrl('CountryGetList')
  return ApiGet(url)
}

export async function StateGetList(countryCode: string): Promise<IStateResponse> {
  const url = await GetOrderEntryConnectorUrl('StateGetList')
  return ApiGet(url, { countryCode })
}

export async function CodeGetList(categoryID: string): Promise<ICodeResponse> {
  const url = await GetOrderEntryConnectorUrl('CodeGetList')
  return ApiGet(url, { categoryID })
}

export async function CultureGetList() {
  const url = await GetWebConnectorUrl('ShareCultureGetList')
  return ApiGet(url)
}
